import { ConfigProvider, ThemeConfig } from "antd";

const loginTheme: ThemeConfig = {
  components: {
    Input: {
      borderRadiusLG: 4,
      colorText: "#E6E6E6",
      colorBgContainer: "#1F1F1F",
      colorTextPlaceholder: "#8A8A8A",
    },
    Typography: {
      colorText: "#888",
    },
  },
};

const LoginTheme: React.FC<any> = (props) => {
  const { children } = props;
  return <ConfigProvider theme={loginTheme}>{children}</ConfigProvider>;
};

export default LoginTheme;
